// hooks/useDropdownOptions.ts
import { useQuery } from "@tanstack/react-query";
import {
  fetchClearerName,
  fetchClearer,
  fetchComodityOptions,
  fetchclearingAccountOptions,
  fetchBookOptions,
  fetchBrokerNameOptions,
  strategyOptions,
  paperTradingCustomerOptions,
  callPaperTradingTypeOptions,
  fetchCommodityOptionsList
} from "./FecthApis";

export const useDropdownOptions = () => {
  // Fetch all dropdown options
  const clearerOptions = useQuery({
    queryKey: ['clearerOptions'],
    queryFn: async () => {
      const { data, error } = await fetchClearerName();
      if (error) throw new Error(error);
      return data;
    },
    staleTime: Infinity
  });

  const clearerOptionsList = useQuery({
    queryKey: ['clearerOptionsList'],
    queryFn: async () => {
      const { data, error } = await fetchClearer();
      if (error) throw new Error(error);
      return data;
    },
    staleTime: Infinity
  });

  const commodityOptions = useQuery({
    queryKey: ['commodityOptions'],
    queryFn: async () => {
      const { data, error } = await fetchCommodityOptionsList();
      if (error) throw new Error(error);
      return data;
    },
    staleTime: Infinity,
  });

  const clearingAccountOptions = useQuery({
    queryKey: ['clearingAccountOptions'],
    queryFn: async () => {
      const { data, error } = await fetchclearingAccountOptions();
      if (error) throw new Error(error);
      return data;
    },
    staleTime: Infinity
  });

  const bookOptions = useQuery({
    queryKey: ['bookOptions'],
    queryFn: async () => {
      const { data, error } = await fetchBookOptions();
      if (error) throw new Error(error);
      return data;
    },
    staleTime: Infinity
  });

  const strategyOptionsList = useQuery({
    queryKey: ['strategyOptions'],
    queryFn: async () => {
      const { data, error } = await strategyOptions();
      if (error) throw new Error(error);
      return data;
    },
    staleTime: Infinity
  });

  const customerCompanyOptions = useQuery({
    queryKey: ['customerCompanyOptions'],
    queryFn: async () => {
      const { data, error } = await paperTradingCustomerOptions();
      if (error) throw new Error(error);
      return data;
    },
    staleTime: Infinity
  });

  const tradeTypeOptions = useQuery({
    queryKey: ['tradeTypeOptions'],
    queryFn: async () => {
      const { data, error } = await callPaperTradingTypeOptions();
      if (error) throw new Error(error);
      return data;
    },
    staleTime: Infinity
  });

  // For dependent dropdowns
  const fetchCommodityOptions = async (clearerId: string) => {
    const { data, error } = await fetchComodityOptions(clearerId);
    if (error) throw new Error(error);
    return data;
  };

  const fetchBrokersForCommodity = async (commodityId: string) => {
    const { data, error } = await fetchBrokerNameOptions(commodityId);
    if (error) throw new Error(error);
    return data;
  };

  return {
    clearerOptions,
    clearingAccountOptions,
    bookOptions,
    strategyOptionsList,
    customerCompanyOptions,
    tradeTypeOptions,
    fetchCommodityOptions,
    fetchBrokersForCommodity,
    clearerOptionsList,
    commodityOptions
  };
};